import { serviceMaker, methods, api } from "./index.js";

export const getBillTrend = data =>
  serviceMaker(
    `/runreports/Monthly%20Usage?R_Yearwise=${data.year}&R_serialNo=${data.slNo}`,
    methods.GET,
    api.NGB
  );
export const getDailyUsage = (slNo, startDate, endDate) =>
  serviceMaker(
    `/runreports/Daily%20Usage?R_endDate=${endDate}&R_serialNo=${slNo}&R_startDate=${startDate}`,
    methods.GET,
    api.NGB
  );

//INVOICE

export const getInvoiceList = clientId =>
  serviceMaker(`/billmaster/${clientId}`, methods.GET, api.NGB);
export const createInvoice = (clientId, data) =>
  serviceMaker(`/billmaster/${clientId}`, methods.POST, api.NGB, data);
export const createOrder = data =>
  serviceMaker(`/paystack/createorder`, methods.POST, api.NGB, data);

//TOPUP
export const getTopup = id =>
  serviceMaker(
    `/clients/getclient360?key=id&value=${id}`,
    methods.GET,
    api.NGB
  );
export const makeOnlinePayment = payload =>
  serviceMaker("/revpay/createorder", methods.POST, api.NGB, payload);
export const getRedeem = payload =>
  serviceMaker(`/redemption`, methods.POST, api.NGB, payload);

// MANAGE SERVICE
export const getManageServiceList = (id, clientId, clientServiceId, planPoId) =>
  serviceMaker(
    `/salescataloge/salescataloges/${id}?clientId=${clientId}&clientServiceId=${clientServiceId}&planId=${planPoId}`,
    methods.GET,
    api.NGB
  );
export const getTicketList = clientId =>
  serviceMaker(`/tickets/${clientId}`, methods.GET, api.NGB);

//payments
export const getPaymentList = clientId =>
  serviceMaker(
    `/financialTransactions/${clientId}/payments`,
    methods.GET,
    api.NGB
  );
export const getTransactionList = clientId =>
  serviceMaker(`/financialTransactions/${clientId}`, methods.GET, api.NGB);

//HELP
export const getTicketTemplate = () =>
  serviceMaker(`/tickets/template`, methods.GET, api.NGB);
export const getTicketSubCategory = categoryId =>
  serviceMaker(
    `/tickets/subcategory?category=${categoryId}`,
    methods.GET,
    api.NGB
  );
export const getTicketTeamUsers = teamUserId =>
  serviceMaker(
    `/tickets/teamusers?teamusers=${teamUserId}`,
    methods.GET,
    api.NGB
  );
export const userByTeam = id =>
  serviceMaker(`/tickets/teamusers?teamusers=${id}`, methods.GET, api.NGB);
export const ticketUpdate = (clientId, data) =>
  serviceMaker(`/tickets/ticketing/${clientId}`, methods.POST, api.NGB, data);
export const createTicketUpdate = (clientId, data) =>
  serviceMaker(`/tickets/customer/${clientId}`, methods.POST, api.NGB, data);
export const cerateTicketsDocument = (entityId, data) =>
  serviceMaker(
    `/officeTicket/${entityId}/documents`,
    methods.POST,
    api.NGB,
    data
  );
// export const getEditTicketById = (clientId, id) =>
//   serviceMaker(`/tickets/${clientId}/update/${id}`, methods.GET, api.NGB);

export const planUpdate = (clientId, data) =>
  serviceMaker(`/orders/changePlan/${clientId}`, methods.PUT, api.NGB, data);

// Profile Section
export const searchCustomerId = id =>
  serviceMaker(
    `/clients/getclient360?key=id&value=${id}`,
    methods.GET,
    api.NGB
  );
export const editcustomer = (payload, id) =>
  serviceMaker(`/clients/${id}`, methods.PUT, api.NGB, payload);
export const updatepassword = payload =>
  serviceMaker(`/selfcare/changepassword`, methods.PUT, api.NGB, payload);

export const getInvoicesDetails = id =>
  serviceMaker(`/billmaster/${id}/billdetails`, methods.GET, api.NGB);
